module.exports = "<button mat-stroked-button class=\"pnd-Recenter\">\n  <mat-icon>location_searching</mat-icon>\n</button>\n"